<template>
  <el-drawer :visible.sync="show" custom-class="z-table__drawer" size="440px">
    <div class="drawer-title" slot="title">
      {{ $t('ad-analysis::管理指标') }}
      <span class="drawer-tip">{{ $t('ad-analysis::拖动可调整位置') }}</span>
    </div>
    <div class="z-table__drawer__body">
      <div class="z-table__drawer__tip">
        {{ $t('ad-analysis::首页指标') }}
        <span style="color: #999">{{ $t('ad-analysis::最多展示6个') }}</span>
      </div>
      <draggable :list="select" class="table-drag" v-bind="dragOptions">
        <div class="column-item" v-for="(i, index) in select" :key="i.prop">
          <div>
            <i class="iconfont iconSort drag-icon icon move" title="移动"></i>
            <span class="label">{{ i.label }}</span>
          </div>
          <i
            class="iconfont icona-19yichu"
            :class="select.length <= 3 && 'disabled'"
            @click="moveItem('select', index)"
          ></i>
        </div>
      </draggable>
      <div class="z-table__drawer__tip">{{ $t('ad-analysis::未显示指标') }}</div>
      <draggable :list="unSelect" class="table-drag" v-bind="dragOptions">
        <div class="column-item" v-for="(i, index) in unSelect" :key="i.prop">
          <div>
            <i class="iconfont iconSort drag-icon icon move" title="移动"></i>
            <span class="label">{{ i.label }}</span>
          </div>
          <i
            class="iconfont icona-20tianjia"
            :class="select.length >= 6 && 'disabled'"
            @click="moveItem('unSelect', index)"
          ></i>
        </div>
      </draggable>
    </div>
    <div class="z-table__drawer__action">
      <div></div>
      <div>
        <el-button size="small" @click="reset">
          {{ $t('system::common::btn::reset') }}
        </el-button>
        <el-button size="small" type="primary" @click="sumbit">
          {{ $t('system::common::btn::confirm') }}
        </el-button>
      </div>
    </div>
  </el-drawer>
</template>
<script>
import draggable from 'vuedraggable'
import { postUserSetting } from '@/server/user'
import { CardKeyList, FbCardKeyList } from '../staticData'
export default {
  name: 'DraggableList',
  components: {
    draggable,
  },
  props: {
    value: {},
    list: {
      type: Array,
    },
    type: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      show: false,
      select: [],
      unSelect: [],
    }
  },
  watch: {
    show(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.show = val
      if (val) {
        this.select = []
        this.unSelect = []
        this.list.forEach(el => {
          if (el.actived) {
            this.select.push({ ...el })
          } else {
            this.unSelect.push({ ...el })
          }
        })
      }
    },
  },
  computed: {
    dragOptions() {
      return {
        handle: '.drag-icon',
        dragClass: 'drag-item',
        chosenClass: 'chosenClass',
        forceFallback: true,
        animation: 100,
        fallbackOnBody: true,
        swapThreshold: 0.65,
        scrollSensitivity: 100,
        fallbackTolerance: 1,
        bubbleScroll: true,
        scrollSpeed: 2000,
        scroll: true,
      }
    },
  },
  methods: {
    moveItem(type, index) {
      if (type === 'select' && this.select.length > 3) {
        let item = this.select.splice(index, 1)[0]
        item.actived = false
        this.unSelect.push(item)
      } else if (type === 'unSelect' && this.select.length < 6) {
        let item = this.unSelect.splice(index, 1)[0]
        item.actived = true
        this.select.push(item)
      }
    },
    reset() {
      this.select = []
      this.unSelect = []
      const list = this.type === 1 ? FbCardKeyList : CardKeyList
      list.forEach(el => {
        if (el.actived) {
          this.select.push({ ...el })
        } else {
          this.unSelect.push({ ...el })
        }
      })
    },
    async sumbit() {
      let config = JSON.stringify([...this.select, ...this.unSelect])
      const { data } = await postUserSetting({ type: this.type, config: config, status: 1 })
      if (data.code === this.$code) {
        this.$emit('onSave', [...this.select, ...this.unSelect])
        this.show = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #010517;
}
.table-drag {
  padding-bottom: 16px;
  color: #c4c8d0;
}
.move {
  cursor: move;
}
.column-item {
  height: 48px;
  background: #ffffff;
  border: 1px solid #dfe3e9;
  display: flex;
  align-items: center;
  padding: 0 16px;
  margin-top: 12px;
  justify-content: space-between;
  ::v-deep {
    .el-checkbox {
      margin: 0 $--base-margin;
    }
  }
  .label {
    font-size: 14px;
    color: #010517;
    margin-left: 16px;
  }
  .icona-19yichu {
    color: #ff0022;
  }
  .icona-20tianjia {
    color: #0560fd;
  }
  .icona-19yichu,
  .icona-20tianjia {
    cursor: pointer;
    &.disabled {
      color: #999;
      cursor: not-allowed;
    }
  }
}
.column-item.drag-item {
  opacity: 1 !important;
  cursor: move !important;
  background-color: #fff;
}
.drawer-title {
  font-size: 16px;
  color: #010517;
  font-weight: bold;
  display: flex;
  align-items: center;
}
.drawer-tip {
  color: #999;
  font-size: 14px;
  margin-left: 16px;
  font-weight: normal;
}
// /deep/ .el-drawer__body {
//   background: #f0f2f5;
// }
.z-table__drawer {
  width: 440px !important;
  background: #f0f2f5;
  padding-top: 80px;
  /deep/ .el-drawer__body {
    height: 100%;
    position: relative;
  }
  &__body {
    padding: 20px 16px 64px;
    height: 100%;
    box-sizing: border-box;
    background: #f0f2f5;
    // display: flex;
    // flex-direction: column;
  }
  &__tip {
    color: #010517;
    // position: absolute;
    // top: 0;
    // left: 0;
    // right: 0;
    // padding-left: 16px;
  }
  &__drag {
    overflow: auto;
    height: 100%;
    padding: 0 16px;
  }
  &__action {
    background-color: #fff;
    position: fixed;
    bottom: 0;
    right: 0;
    height: 63px;
    border-top: 1px solid $--border-color-base;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    width: 440px;
    box-sizing: border-box;
    z-index: 999;
  }

  :focus {
    outline: 0;
  }
}
</style>
